import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Subject, takeUntil } from 'rxjs';
import { AppMainService } from 'src/app/app-main.service';
import { SharedCRMConfigService } from 'src/app/configurations/crm/shared/services/shared-crm-config.service';
import { AccountModuleId, CaseModuleId, ContactModuleId, LeadModuleId, workspaceModuleId } from 'src/app/modules/shared/constants/modules.constant';
import { SharedChannelService } from 'src/app/modules/shared/services/channel.service';
import { WorkspaceService } from '../services/workspace.service';
import { DynamicTableService } from 'src/app/modules/shared/services/dynamic-table/dynamic-table.service';
import { ColumnDefinition } from 'src/app/modules/shared/models/dynamic-table/dynamic-table-data.model';
import { WorkbookList, WorkSpaceList } from '../models/workspace.models';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormErrorHandler } from 'src/app/modules/shared/helpers/form-error-handler.helper';
import { FormControlList } from 'src/app/modules/shared/constants/formcontrol-list.constants';
import { ParseHelper } from 'src/app/modules/shared/parse.helper';
import { ImportService } from 'src/app/modules/shared/services/import.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { noWhiteSpaceValidator, trimFirstWhiteSpaces } from 'src/app/modules/shared/validators/trim-white-spaces.validator';
import { RowPolicy, WorkbookCopyMoveRequest, MappingField } from '../models/workbook-copy-move.models';

interface DropdownListM { id: number; name: string; }
@Component({
  selector: 'app-workbook-row-to-module-object',
  templateUrl: './workbook-row-to-module-object.component.html',
  styleUrl: './workbook-row-to-module-object.component.scss'
})

export class WorkbookRowToModuleObjectComponent implements OnInit, OnDestroy {
  @Input() selectedModuleId: number = AccountModuleId;
  @Input() selectedWorkspaceId: string = '';
  @Input() selectedWorkbookId: string = '';
  @Input() selectedRow: any = {};
  @Input() displayDialog: boolean = false;
  @Input() isCopyMoveWBRow: boolean = false;
  @Input() isCopyWBRow: boolean = false;
  @Input() isMoveWBRow: boolean = false;
  @Input() isCreateDuplicateRow: boolean = false;
  @Output() dialogClosed = new EventEmitter<boolean>();
  @ViewChild('fieldmapping') fieldmapping: any;
  @ViewChild('sharedWorkbookListing') sharedWorkbookListing: any;

  workspaceModuleId = workspaceModuleId;
  caseModuleId = CaseModuleId;
  private readonly headerTitles = {
    duplicate: "Create Duplicate Workbook",
    copy: "Copy Workbook Row To Other Workbook",
    move: "Move Workbook Row To Other Workbook"
  };
  headerTitle: string = "Convert Workbook Row Into Module Object";
  modulesList: DropdownListM[] = [
    { id: AccountModuleId, name: 'Account' },
    { id: LeadModuleId, name: 'Lead' },
    { id: CaseModuleId, name: 'Cases' },
    // {id: ContactModuleId, name: 'Contact'},
  ];
  selectedModule: DropdownListM | null = null;
  moduleChannels: DropdownListM[] = [];
  productTemplates: any[] = [];
  productSectionNames: any[] = [];
  selectedChannel: DropdownListM | null = null;
  workspaceList: WorkSpaceList[] = [];
  workBookList: WorkbookList[] = [];


  sectionColumns: any[] = [];

  displayFieldMapping: boolean = false;
  importFiles: any[] = [];
  selectedFile: File | null = null;
  //** Workspace import variables *
  selectedWorkspace: WorkSpaceList | null = null;
  selectedWorkbook: WorkbookList | null = null;
  workbookColumns: ColumnDefinition[] = [];

  addToModuleForm: FormGroup = new FormGroup({});
  isUnsavedData: boolean = false;
  detailsFormErrors: any = {};

  moduleColumnList: any[] = [];

  /** Workbook */
  currentStep: number = 1;
  selectedRowForConversion: any[] = [];


  selectedFileHeaders: {
    excelHeader: string;
    excelColumn: string;
    columnNumber: number;
    moduleField: any;
    moduleFields: any[]; 
    dataType?: string;
  }[] = [];

  importActions: { name: string, value: string }[] = [
    {
      name: 'Add',
      value: 'add'
    },
    {
      name: 'Update',
      value: 'edit'
    },
    {
      name: 'Add and Update',
      value: 'addedit'
    }
  ];

  selectedAction = this.importActions[0];
  uploadedFiles: any[] = [];


  displayRowSelectionModal = false;
  // selectedRowForConversion: any[] = [];
  tempSelectedRows: any[] = [];
  workbookColumnsForTable: ColumnDefinition[] = [];

  // Add new properties for copy/move functionality
  targetWorkspaceList: WorkSpaceList[] = [];
  targetWorkBookList: WorkbookList[] = [];
  selectedTargetWorkspace: WorkSpaceList | null = null;
  selectedTargetWorkbook: WorkbookList | null = null;
  workspaceForCreateWB: WorkSpaceList[] = [];

  // Add missing property
  workbookRows: any[] = [];

  // Add new properties for toggle functionality
  copyAllComments: boolean = false;
  copyAllDocuments: boolean = false;

  // New properties for Create a new workbook using columns from an existing workbook
  selectedColumnForNewWb: ColumnDefinition[] = [];
  displayCreateWorkbookDialog: boolean = false;
  createWorkbookForm: FormGroup = new FormGroup({});
  sourceWorkspaceForCreateWB: WorkSpaceList[] = [];
  sourceWorkbookForCreateWB: WorkbookList[] = [];
  selectedSourceWorkspace: WorkSpaceList | null = null;
  selectedSourceWorkbook: WorkbookList | null = null;
  sourceWorkbookColumns: ColumnDefinition[] = [];

  ngUnsubscribe$ = new Subject<void>();

  constructor(
    private formBuilder: FormBuilder,
    private messageService: MessageService,
    private appMainService: AppMainService,
    private sharedChannelService: SharedChannelService,
    private sharedConfigService: SharedCRMConfigService,
    private readonly workspaceService: WorkspaceService,
    private readonly dynamicTableService: DynamicTableService,
    private readonly formErrorHandler: FormErrorHandler,
    private readonly importService: ImportService,
    public app: AppMainComponent,

  ) { }

  ngOnInit(): void {
    this.initAddToListForm();
    this.getWorkspaceList();
    if (this.isCopyMoveWBRow) {
      this.selectedModule = {
        name: 'Workbook',
        id: workspaceModuleId
      }
      this.headerTitle = this.isCreateDuplicateRow 
        ? this.headerTitles.duplicate 
        : this.isCopyWBRow 
          ? this.headerTitles.copy 
          : this.headerTitles.move;
      
      this.initCreateWorkbookForm(); //For create new workbook.
    } else {
      this.getChannels();
    }
  }

  initAddToListForm() {
    const defaultChannelId = 1;
    this.detailsFormErrors = {};
    this.isUnsavedData = false;
    
    // Create form controls based on mode
    const formControls: any = {
      selectedWorkspace: [this.selectedWorkspaceId, [Validators.required]],
      selectedWorkbook: [null, [Validators.required]],
      addRow: this.formBuilder.array([], [Validators.required, Validators.minLength(1)])
    };

    // Add module and channel controls only for convert mode
    if (!this.isCopyMoveWBRow) {
      formControls.selectedModule = [this.selectedModuleId, [Validators.required]];
      formControls.selectedChannel = [defaultChannelId, [Validators.required]];
    }

    // Add target workspace and workbook controls for copy/move mode
    if (this.isCopyMoveWBRow) {
      formControls.selectedTargetWorkspace = [null, [Validators.required]];
      formControls.selectedTargetWorkbook = [null, [Validators.required]];
    }

    this.addToModuleForm = this.formBuilder.group(formControls);

    // Update validation messages based on mode
    const validationMessages: any = {
      selectedWorkspace: {
        required: "Select Workspace"
      },
      selectedWorkbook: {
        required: "Select Workbook"
      },
      addRow: {
        required: "Select Row"
      }
    };

    if (!this.isCopyMoveWBRow) {
      validationMessages.selectedModule = {
        required: "Select Module"
      };
      validationMessages.selectedChannel = {
        required: "Select Channel"
      };
    } else {
      validationMessages.selectedTargetWorkspace = {
        required: "Select Target Workspace"
      };
      validationMessages.selectedTargetWorkbook = {
        required: "Select Target Workbook"
      };
    }

    this.formErrorHandler.handleErrors(this.addToModuleForm, this.detailsFormErrors, validationMessages);
    this.addToModuleForm.valueChanges.pipe(takeUntil(this.ngUnsubscribe$)).subscribe(e => this.isUnsavedData = true);
  }

  convertRowToModuleObject() {
    if (this.addToModuleForm.invalid) {
      this.addToModuleForm.markAllAsTouched();
      this.formErrorHandler.showErrorOnSubmit();
      if (this.addRowArray.length === 0) {
        this.messageService.add({
          severity: 'error',
          summary: 'Validation Error',
          detail: 'You need to select at least one row before proceeding.'
        });
        return;
      }
    } 
    
    // Check field mapping validation for both convert and copy/move modes
    const hasMappedFields = this.selectedFileHeaders.some(fileHeader => 
      Array.isArray(fileHeader.moduleFields) && fileHeader.moduleFields.length > 0
    );
    
    if (!hasMappedFields) {
      this.messageService.add({
        severity: 'error',
        summary: 'Mapping Error',
        detail: 'At least one field must be mapped before proceeding.'
      });
      return;
    }
    
    // If all validations pass, proceed with the operation
    if (this.isCopyMoveWBRow) {
      this.handleCopyMove();
    } else {
      this.fieldmapping.importData();
    }
  }
  getChannels() {
    this.selectedChannel = null;
    this.selectedModuleId = this.addToModuleForm.value.selectedModule;
    this.selectedModule = this.modulesList.find(m => m?.id == this.selectedModuleId) || null;
    if ([AccountModuleId, LeadModuleId, CaseModuleId].includes(this.selectedModuleId)) {
      this.getCRMChannels(this.selectedModuleId);
    }
  }

  /**
   * Handles channel change and updates section columns
   */
  onChannelChange(event: any) {
    const channelId = event.value;
    this.selectedChannel = this.moduleChannels.find(c => c.id === channelId) || null;
    
    // Reset section columns when channel changes
    this.sectionColumns = [];
    this.displayFieldMapping = false;
    
    // Get columns for the new channel
    if (channelId && this.selectedModule?.id) {
      this.getCRMColumns();
    } else {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please select both module and channel to view available fields'
      });
    }
  }

  getCRMChannels(moduleId: number): void {
    this.appMainService.isShowSpinner('getModuleChannels');
    this.sharedChannelService.getChannels(moduleId, [CaseModuleId].includes(moduleId))
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe({
        next: (response) => {
          this.moduleChannels = response || [];
          this.getCRMColumns();
          this.appMainService.isHideSpinner('getModuleChannels');
        },
        error: (error) => {
          this.appMainService.isHideSpinner('getModuleChannels');
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: error?.error?.message ? error?.error?.message : 'Channels are not loaded, please try again...'
          });
        }
      });
  }

  getCRMColumns(): void {
    const channelId = this.addToModuleForm.value.selectedChannel;
    if (!channelId || !this.selectedModule?.id) {
      return;
    }

    this.appMainService.isShowSpinner("getCRMColumns");
    this.sharedConfigService.getTemplateImportFields(this.selectedModule.id, channelId)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe({
        next: (response: any) => {
          this.appMainService.isHideSpinner("getCRMColumns");
          this.displayFieldMapping = true;
          this.sectionColumns = response;
          const notForImport = ['createdByUserName', 'createdByName', 'createdDate', 'updatedDate', 'updatedByUserName', 'updatedByName', 'previousStage', 'stageChangedBy', 'stageChangedDate', 'leadGrade', 'leadScore', 'scoreTrend', 'sequenceNumber', 'taskDueDate', 'taskOverDueDate', 'lastEventDate', 'lastActivityDate', 'latestEventDate'];
          const notForImportControls = [FormControlList.FileUpload, FormControlList.Picture, FormControlList.AutoNumber, FormControlList.Formula];

          this.sectionColumns.map(section => {
            section.customFields.map(field => {
              field['isCustom'] = true;
            });
            section.fields.push(...section.customFields);
            section.fields = section.fields.filter(field => !notForImport.includes(field.field) && !notForImportControls.includes(field?.formControl?.type || field?.formControl));
            section.fields.map((fieldData) => {

              fieldData.isRequired = false;
              fieldData.isDisabled = false;

              if (this.selectedAction?.value == 'add' && ['contactFirstName', 'firstName'].includes(fieldData.field) && [LeadModuleId, AccountModuleId].includes(this.selectedModule?.id)) {
                fieldData.enabledInForm = true;
                fieldData.isRequired = true;
                fieldData.isDisabled = true;
              }

              if (this.selectedAction?.value == 'add' && ['contactAssociation', 'businessName', 'firstName'].includes(fieldData.field) && [ContactModuleId].includes(this.selectedModule?.id)) {
                fieldData.enabledInForm = true;
                fieldData.isRequired = true;
                fieldData.isDisabled = true;
              }

              if (this.selectedAction?.value == 'add' && ['caseNumber', 'subject', 'description'].includes(fieldData.field) && [CaseModuleId].includes(this.selectedModule?.id)) {
                fieldData.enabledInForm = true;
                fieldData.isRequired = true;
                fieldData.isDisabled = true;
              }

              if (this.selectedAction?.value != 'add' && ['sequenceNumber'].includes(fieldData.field) && [ContactModuleId].includes(this.selectedModule?.id)) {
                fieldData.enabledInForm = true;
                fieldData.isRequired = true;
                fieldData.isDisabled = true;
              }

              fieldData['ischecked'] = fieldData.enabledInForm || false;
              fieldData['custom'] = fieldData?.isCustom || false;

              if (fieldData.childFields?.length > 0) {
                fieldData.childFields = fieldData.childFields.filter(field => !notForImport.includes(field.field) && !notForImportControls.includes(field?.formControl?.type || field?.formControl));
                fieldData.childFields.map(childField => {
                  childField['ischecked'] = childField.enabledInForm || false;
                  childField['custom'] = childField?.isCustom || false;
                  childField['isRequired'] = false;
                  childField['isDisabled'] = false;
                })
              }
            });
          });
          this.sectionColumns = ParseHelper.DeepCopy(this.sectionColumns);
        },
        error: (error) => {
          this.appMainService.isHideSpinner("getCRMColumns");
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: error?.error?.message || 'Failed to load columns for the selected channel'
          });
        }
      });
  }


  getWorkspaceList() {
    this.appMainService.isShowSpinner('getWorkspaceList');
    this.workspaceService
      .getWorkspaceList()
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe({
        next: (response: WorkSpaceList[]) => {
          this.appMainService.isHideSpinner('getWorkspaceList');
          this.workspaceList = response;
          if(this.isCopyMoveWBRow && this.isCreateDuplicateRow){
            this.targetWorkspaceList= [...response];
            this.addToModuleForm.patchValue({
              selectedTargetWorkspace: this.selectedWorkspaceId
            });
        }
          if (this.selectedWorkspaceId) {
            this.selectedWorkspace = this.workspaceList.find(w => w?.id == this.selectedWorkspaceId) || null;
            this.getWorkbookList(this.selectedWorkspace.id);
          }
        },
        error: (error) => {
          this.appMainService.isHideSpinner('getWorkspaceList');
        },
      });
  }
  onWorkspaceChange($event: any) {
    const workspaceId = this.addToModuleForm.value.selectedWorkspace;
    this.getWorkbookList(workspaceId);
  }


  openAddRowPopup() {
    this.selectedRowForConversion = this.addRowArray.value.map((r: any) => {
      const { rowNumber, rowData } = r.row;
      return {
        rowNumber,
        rowData
      };
    });
    this.displayRowSelectionModal = true;
  }
  closeRowSelectionModal() {
    this.tempSelectedRows = [];
    this.displayRowSelectionModal = false;
  }
  handleMultiRowSelection(rows: any[]) {
    this.selectedRowForConversion = [...rows].sort((a, b) => a.rowNumber - b.rowNumber);
    const existingRowNumbers = this.addRowArray.value
      .map((r: any) => r?.row?.rowNumber)
      .filter((rowNumber: any) => rowNumber !== undefined);

    // Add new rows to the FormArray
    this.selectedRowForConversion.forEach(row => {
      if (!existingRowNumbers.includes(row.rowNumber) && !this.addRowArray.value.some((r: any) => r.row.rowNumber === row.rowNumber)) {
        const rowGroup = this.formBuilder.group({
          row: [row],
          copyComment: [false],
          copyDocument: [false]
        });
        this.addRowArray.push(rowGroup);
      }
    });

    // Remove rows from the FormArray if they are no longer in selectedRowForConversion
    for (let i = this.addRowArray.length - 1; i >= 0; i--) {
      const rowNumber = this.addRowArray.at(i).value.row.rowNumber;
      if (!this.selectedRowForConversion.some(row => row.rowNumber === rowNumber)) {
        this.addRowArray.removeAt(i);
      }
    }

    // Sort the FormArray based on rowNumber
    const sortedRows = this.addRowArray.value.sort((a: any, b: any) => a.row.rowNumber - b.row.rowNumber);
    this.addRowArray.clear();
    sortedRows.forEach((row: any) => {
      const rowGroup = this.formBuilder.group({
        row: [row.row],
        copyComment: [row.copyComment],
        copyDocument: [row.copyDocument]
      });
      this.addRowArray.push(rowGroup);
    });

   this.closeRowSelectionModal();
  }


  get addRowArray(): FormArray {
    return this.addToModuleForm.get('addRow') as FormArray;
  }

  removeWorkbookRow(index: number) {
    this.addRowArray.removeAt(index);
  }

  onWorkbookChange(event: any) {
    const workbookId = this.addToModuleForm.value.selectedWorkbook;
    this.selectedWorkbook = this.workBookList.find(w => w?.id == workbookId) || null;
    this.getWorkbookColumn(workbookId);
  }

  getWorkbookColumn(workbookId: string, isTargetWbColumn: boolean = false) {
    this.appMainService.isShowSpinner('getWorkbookColumn');
    this.dynamicTableService.getDynamicTableColumn(workbookId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
      next: (response: ColumnDefinition[]) => {
        this.appMainService.isHideSpinner('getWorkbookColumn');
        if(this.isCopyMoveWBRow && this.isCreateDuplicateRow){
            this.sectionColumns = this.mapWorkbookColumnDefinitions(response);
            this.displayFieldMapping = true;
        }
        if(!isTargetWbColumn){
          this.workbookColumns = [...response];
          this.selectedFileHeaders = this.workbookColumns.map((col: ColumnDefinition) => ({
            excelHeader: col.name,
            excelColumn: col.formControlName,
            columnNumber: col?.intId ,
            moduleField: null,
            moduleFields: [],
            dataType: col.label,
          }));
        }
        else{
            const targetWorkBookColumn = [...response];
            this.sectionColumns = this.mapWorkbookColumnDefinitions(targetWorkBookColumn);
            this.displayFieldMapping = true;
        }
      },
      error: (error) => {
        this.appMainService.isHideSpinner('getWorkbookColumn');
      }
    })
  }

  getWorkbookList(workspaceId) {
    this.appMainService.isShowSpinner('getWorkbookList');
    this.workspaceService
      .getWorkspaceItemsDetailsByID(workspaceId)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe({
        next: (response) => {
          this.appMainService.isHideSpinner('getWorkbookList');
          if (this.selectedWorkbookId) {
            this.selectedWorkbook = response.find(w => w.id == this.selectedWorkbookId) || null;
            this.addToModuleForm.patchValue({
              selectedWorkbook: this.selectedWorkbook?.id
            });
          }
          this.workBookList = response;
          if(this.isCopyMoveWBRow && this.isCreateDuplicateRow){
            this.targetWorkBookList = [...response];
            this.addToModuleForm.patchValue({
              selectedTargetWorkbook: this.selectedWorkbook?.id
            });
        }
          this.getWorkbookColumn(this.selectedWorkbookId);          

        },
        error: (error) => {
          this.appMainService.isHideSpinner('getWorkbookList');
        },
      });
  }

  closeDialog(): void {
    this.displayDialog = false;
    this.currentStep = 1;
    this.displayFieldMapping = false;
    this.dialogClosed.emit(true);
  }

  importFileUploaded(event: any) {
    this.displayDialog = false;
  }
  closMappingModal() {
    this.displayFieldMapping = false;
  }

  handleRowSelection(selectedRows: any[]) {
    this.selectedRowForConversion = selectedRows;
  }

  resetSelection() {
    this.sharedWorkbookListing.resetSelection();
  }
  saveSelection() {
    this.sharedWorkbookListing.saveSelection();
    this.workbookColumnsForTable = this.sharedWorkbookListing.workbookColumns;
    this.selectedRowForConversion = this.sharedWorkbookListing.selectedRowForConversion;
  }

  handleWorkbookColumnsChange(workbookColumns: ColumnDefinition[]) {
    this.workbookColumnsForTable = workbookColumns;
    this.workbookColumnsForTable = this.sharedWorkbookListing.workbookColumns;
    if(this.selectedRow){
      const mappedRow = {
        rowNumber: this.selectedRow['RowNumber'],
        rowData: this.selectedRow['rowData']
      };
      // this.sharedWorkbookListing.saveSelection();
      this.handleMultiRowSelection([mappedRow]);
    }
    else{
      this.selectedRowForConversion = this.sharedWorkbookListing.selectedRowForConversion;
    }
  }


  // Add new method to handle target workspace change
  onTargetWorkspaceChange(event: any) {
    const workspaceId = event.value;
    this.selectedTargetWorkspace = this.targetWorkspaceList.find(ws => ws.id === workspaceId) || null;
    this.selectedTargetWorkbook = null;
    this.sectionColumns = [];
    this.addToModuleForm.patchValue({ selectedTargetWorkbook: null });
    if (workspaceId) {
      this.getTargetWorkbookList(workspaceId);
    } else {
      this.targetWorkBookList = [];
    }
  }

  // Add new method to get target workbook list
  getTargetWorkbookList(workspaceId: string, isDuplicate: boolean = false, workBookId?: string) {
    this.appMainService.isShowSpinner('getTargetWorkbookList');
    this.workspaceService.getWorkspaceItemsDetailsByID(workspaceId).pipe(
      takeUntil(this.ngUnsubscribe$)
    ).subscribe({
      next: (response) => {
        this.appMainService.isHideSpinner('getTargetWorkbookList');
        this.targetWorkBookList = response;
        //To handle patch created workbook ID
        if(isDuplicate){ 
          this.addToModuleForm.patchValue({
            selectedTargetWorkbook: workBookId
          });
          this.onTargetBookChange(workBookId);
        }
      },
      error: (error) => {
        this.appMainService.isHideSpinner('getTargetWorkbookList');
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error?.error?.message || 'Failed to load target workbooks'
        });
      }
    });
  }

  onTargetBookChange(event){
    const targetWorkbookId = this.addToModuleForm.value.selectedTargetWorkbook;
    this.getWorkbookColumn(targetWorkbookId, true);
  }
  mapWorkbookColumnDefinitions(columnDefinitions: ColumnDefinition[]): any[] {
    return [
        {
        customFields: [],
        fields: columnDefinitions.map((col) => ({
            id: col.id,
            name: col.name,
            labelName: col.name,
            field: col.name,
            formControlId: col.formControlId,
            formControl: col.formControlName,
            // mapObject: 'workspace',
            enabledInForm: true,
            isDateWithTime: false,
            readOnly: false,
            childFields: [],
            ischecked: true,
            custom: true,
            isRequired : false,
            isDisabled : false,
            intId: col.intId,
        })),
        id: 1,
        name: 'Workbook columns',
        systemGenerated: true,
        },
    ];
    }

  /**
   * Creates the payload for adding rows from workbook
   */
  private createAddRowFromWorkbookPayload(): WorkbookCopyMoveRequest {
    const rowPolicies: RowPolicy[] = this.addRowArray.value.map(row => ({
      rowNumber: row.row.rowNumber,
      copyComment: row.copyComment,
      copyDocument: row.copyDocument,
      move: this.isMoveWBRow
    }));

    const mappingFields: MappingField[] = this.selectedFileHeaders
      .filter(fileHeader => Array.isArray(fileHeader.moduleFields) && fileHeader.moduleFields.length)
      .flatMap(fileHeader =>
        fileHeader.moduleFields.map(moduleField => ({
          fileHeader: fileHeader.excelHeader,
          columnNumber: fileHeader.columnNumber,
          labelName: moduleField.labelName,
          field: moduleField.labelName,
          custom: moduleField.custom,
          formControlId: moduleField.intId,
          IsRequired: false,
          refrenceColumnId: moduleField.id,
        }))
      );

    const targetWorkbook = this.targetWorkBookList.find(w => w?.id == this.addToModuleForm.value.selectedTargetWorkbook) || null;
    const selectedWorkbook = this.workBookList.find(w => w?.id == this.selectedWorkbookId) || null;

    const copyMoveWorkbookRow: WorkbookCopyMoveRequest = {
      actionType: "add",
      mappingFields: JSON.stringify(mappingFields),
      objectName: "Workbook",
      objectId: workspaceModuleId,
      channelId: 1,
      WorkspaceId: this.addToModuleForm.value.selectedWorkspace,
      WorkbookId: selectedWorkbook?.id,
      SourceId: selectedWorkbook?.intId,
      SourceType: "Workbook",
      TargetId: targetWorkbook?.intId,
      TargetGId: targetWorkbook?.id,
      SourceGId: selectedWorkbook?.id,
      TargetType: "Workbook",
      ImportFileWorkbookRows: rowPolicies,
    };

    return copyMoveWorkbookRow;
  }

  /**
   * Makes the API call to add rows from workbook
   */
  private addRowsFromWorkbook(payload: WorkbookCopyMoveRequest) {
    this.appMainService.isShowSpinner('addRowsFromWorkbook');
    this.importService.copyMoveWorkbookToAccount(payload).pipe(
      takeUntil(this.ngUnsubscribe$)
    ).subscribe({
      next: (response) => {
        this.appMainService.isHideSpinner('addRowsFromWorkbook');
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: `Workbook rows ${this.isCopyWBRow ? 'copied': this.isMoveWBRow ? 'moved' : 'copied'} successfully`
        });
        this.closeDialog();
      },
      error: (error) => {
        this.appMainService.isHideSpinner('addRowsFromWorkbook');
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error?.error?.message || `Failed to ${this.isCopyWBRow ? 'copy' : 'move'} workbook rows`
        });
      }
    });
  }

  /**
   * Handles the copy/move operation
   */
  private handleCopyMove() {
    try {
      const payload = this.createAddRowFromWorkbookPayload();
      this.addRowsFromWorkbook(payload);
    } catch (error) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to prepare data for operation'
      });
    }
  }
    
  ngOnDestroy(): void {
    if (this.ngUnsubscribe$) {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
        this.ngUnsubscribe$.unsubscribe();
    }
}

/**
 * Toggles copy all comments for all rows
 */
toggleCopyAllComments() {
  this.copyAllComments = !this.copyAllComments;
  this.addRowArray.controls.forEach(control => {
    control.patchValue({ copyComment: this.copyAllComments });
  });
}

/**
 * Toggles copy all documents for all rows
 */
toggleCopyAllDocuments() {
  this.copyAllDocuments = !this.copyAllDocuments;
  this.addRowArray.controls.forEach(control => {
    control.patchValue({ copyDocument: this.copyAllDocuments });
  });
}

/**
 * Handles individual comment toggle and updates copyAllComments state
 */
onCommentToggle() {
  const allCommentsChecked = this.addRowArray.controls.every(control => control.value.copyComment);
  this.copyAllComments = allCommentsChecked;
}

/**
 * Handles individual document toggle and updates copyAllDocuments state
 */
onDocumentToggle() {
  const allDocumentsChecked = this.addRowArray.controls.every(control => control.value.copyDocument);
  this.copyAllDocuments = allDocumentsChecked;
}

  // Multi-step form navigation methods
  nextStep(): void {
    if (this.currentStep === 1) {
      // Mark all form controls as touched to show validation errors
      this.addToModuleForm.markAllAsTouched();
      
      // Check if workspace and workbook are selected
      const workspaceValid = this.addToModuleForm.get('selectedWorkspace')?.valid;
      const workbookValid = this.addToModuleForm.get('selectedWorkbook')?.valid;
      
      if (!workspaceValid) {
        this.messageService.add({
          severity: 'error',
          summary: 'Validation Error',
          detail: 'Please select a workspace.'
        });
        return;
      }
      
      if (!workbookValid) {
        this.messageService.add({
          severity: 'error',
          summary: 'Validation Error',
          detail: 'Please select a workbook.'
        });
        return;
      }
      
      // Check if at least one row is selected
      const rowsValid = this.addRowArray.controls.length > 0;
      if (!rowsValid) {
        this.messageService.add({
          severity: 'error',
          summary: 'Validation Error',
          detail: 'Please select at least one row to proceed.'
        });
        return;
      }
      
      // For convert mode, also check module and channel
      if (!this.isCopyMoveWBRow) {
        const moduleValid = this.addToModuleForm.get('selectedModule')?.valid;
        const channelValid = this.addToModuleForm.get('selectedChannel')?.valid;
        
        if (!moduleValid) {
          this.messageService.add({
            severity: 'error',
            summary: 'Validation Error',
            detail: 'Please select a module.'
          });
          return;
        }
        
        if (!channelValid) {
          this.messageService.add({
            severity: 'error',
            summary: 'Validation Error',
            detail: 'Please select a channel.'
          });
          return;
        }
      }
      
      // For copy/move mode, check target workspace and workbook
      if (this.isCopyMoveWBRow) {
        const targetWorkspaceValid = this.addToModuleForm.get('selectedTargetWorkspace')?.valid;
        const targetWorkbookValid = this.addToModuleForm.get('selectedTargetWorkbook')?.valid;
        
        if (!targetWorkspaceValid) {
          this.messageService.add({
            severity: 'error',
            summary: 'Validation Error',
            detail: 'Please select a target workspace.'
          });
          return;
        }
        
        if (!targetWorkbookValid) {
          this.messageService.add({
            severity: 'error',
            summary: 'Validation Error',
            detail: 'Please select a target workbook.'
          });
          return;
        }
      }
      
      // If all validations pass, proceed to next step
      this.currentStep = 2;
      this.displayFieldMapping = true;
    }
  }

  previousStep(): void {
    if (this.currentStep === 2) {
      this.currentStep = 1;
      this.displayFieldMapping = false;
    }
  }

  isFirstStepValid(): boolean {
    // Check if workspace and workbook are selected
    const workspaceValid = this.addToModuleForm.get('selectedWorkspace')?.valid;
    const workbookValid = this.addToModuleForm.get('selectedWorkbook')?.valid;
    
    // Check if at least one row is selected
    const rowsValid = this.addRowArray.controls.length > 0;
    
    // For convert mode, also check module and channel
    let moduleChannelValid = true;
    if (!this.isCopyMoveWBRow) {
      moduleChannelValid = this.addToModuleForm.get('selectedModule')?.valid && 
                          this.addToModuleForm.get('selectedChannel')?.valid;
    }
    
    // For copy/move mode, check target workspace and workbook
    let targetValid = true;
    if (this.isCopyMoveWBRow) {
      targetValid = this.addToModuleForm.get('selectedTargetWorkspace')?.valid && 
                   this.addToModuleForm.get('selectedTargetWorkbook')?.valid;
    }
    
    return workspaceValid && workbookValid && rowsValid && moduleChannelValid && targetValid;
  }

  //#region Create a new workbook using columns from an existing workbook
  createWorkbookWithSameColumns(){
    const loggedUserId = this.app.user?.userId;
    this.workspaceForCreateWB = this.workspaceList.filter(ws => ws.creadtedByUserId == loggedUserId) || [];
    if(this.workspaceForCreateWB.length>0){
      this.displayCreateWorkbookDialog = true;
      
      // Initialize source selection with current workbook
      this.sourceWorkspaceForCreateWB = [...this.workspaceList];
      this.selectedSourceWorkspace = this.selectedWorkspace;
      this.selectedSourceWorkbook = this.selectedWorkbook;
      this.sourceWorkbookColumns = [...this.workbookColumns];
      this.selectedColumnForNewWb = structuredClone(this.workbookColumns);
      
      this.initCreateWorkbookForm();
      
      // After form initialization, set the source workbook list if source workspace is available
      if (this.selectedWorkspace) {
        this.getSourceWorkbookList(this.selectedWorkspace.id);
      }
    }
    else{
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'You do not have any workspaces to create a workbook'
      });
    }
  }

  initCreateWorkbookForm() {
    // Set default destination workspace as source workspace if available
    const defaultDestinationWorkspace = this.selectedWorkspace && 
      this.workspaceForCreateWB.some(ws => ws.id === this.selectedWorkspace.id) 
      ? this.selectedWorkspace.id 
      : null;
    
    this.createWorkbookForm = this.formBuilder.group({
      workbookName: ['', [Validators.required, Validators.maxLength(30), trimFirstWhiteSpaces, noWhiteSpaceValidator]],
      selectedWorkspace: [defaultDestinationWorkspace, [Validators.required]],
      sourceWorkspace: [this.selectedWorkspace?.id || null, [Validators.required]],
      sourceWorkbook: [this.selectedWorkbook?.id || null, [Validators.required]]
    });
  }

  closeCreateWorkbookDialog() {
    this.displayCreateWorkbookDialog = false;
    this.createWorkbookForm.reset();
    // Reset source selection
    this.selectedSourceWorkspace = null;
    this.selectedSourceWorkbook = null;
    this.sourceWorkbookColumns = [];
    this.selectedColumnForNewWb = [];
    this.sourceWorkbookForCreateWB = [];
  }

  submitCreateWorkbook() {
    if (this.createWorkbookForm.invalid) {
      this.createWorkbookForm.markAllAsTouched();
      return;
    }
    
    // Validate source workbook is selected
    if (!this.createWorkbookForm.get('sourceWorkbook')?.value) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Please select a source workbook'
      });
      return;
    }
    const selectedColumns = this.selectedColumnForNewWb.map(col => col.id);
    if(selectedColumns.length == 0){
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'At least one column must be selected'
      });
      return;
    }
    const payload = {
      destinationWorkspaceId: this.createWorkbookForm.value.selectedWorkspace,
      workbookId: this.createWorkbookForm.value.sourceWorkbook, // Use form value instead of separate property
      workbookName: this.createWorkbookForm.value.workbookName,
      columnIds: selectedColumns
    };

    this.appMainService.isShowSpinner('createWorkbook');
    this.workspaceService.copyWorkbookWithColumns(payload).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
      next: (response) => {
        this.appMainService.isHideSpinner('createWorkbook');
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Workbook created successfully'
        });
        this.selectedColumnForNewWb = [];
        this.closeCreateWorkbookDialog();
        this.addToModuleForm.patchValue({
          selectedTargetWorkspace: payload.destinationWorkspaceId
        });        
        this.getTargetWorkbookList(payload.destinationWorkspaceId, true, response); 
      },
      error: (error) => {
        this.appMainService.isHideSpinner('createWorkbook');
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: error?.error?.Message || 'Failed to create workbook'
        });
      }
    });
  }
  // New methods for flexible source selection
  onSourceWorkspaceChange(event: any) {
    const workspaceId = event.value;
    this.selectedSourceWorkspace = this.sourceWorkspaceForCreateWB.find(ws => ws.id === workspaceId) || null;
    this.selectedSourceWorkbook = null;
    this.sourceWorkbookColumns = [];
    this.selectedColumnForNewWb = [];
    
    // Clear source workbook selection when workspace changes
    this.createWorkbookForm.patchValue({
      sourceWorkbook: null
    });
    
    // Update destination workspace to match source workspace if it's available in the destination list
    if (workspaceId && this.workspaceForCreateWB.some(ws => ws.id === workspaceId)) {
      this.createWorkbookForm.patchValue({
        selectedWorkspace: workspaceId
      });
    }
    
    if (workspaceId) {
      this.getSourceWorkbookList(workspaceId);
    }
  }

  getSourceWorkbookList(workspaceId: string) {
    this.appMainService.isShowSpinner('getSourceWorkbookList');
    this.workspaceService
      .getWorkspaceItemsDetailsByID(workspaceId)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe({
        next: (response) => {
          this.appMainService.isHideSpinner('getSourceWorkbookList');
          this.sourceWorkbookForCreateWB = response;
          
          // Set default source workbook if it's available in the list
          if (this.selectedWorkbook && response.some(wb => wb.id === this.selectedWorkbook.id)) {
            this.createWorkbookForm.patchValue({
              sourceWorkbook: this.selectedWorkbook.id
            });
            this.selectedSourceWorkbook = this.selectedWorkbook;
            this.getSourceWorkbookColumns(this.selectedWorkbook.id);
          }
        },
        error: (error) => {
          this.appMainService.isHideSpinner('getSourceWorkbookList');
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to fetch workbooks for the selected workspace'
          });
        },
      });
  }

  onSourceWorkbookChange(event: any) {
    const workbookId = event.value;
    this.selectedSourceWorkbook = this.sourceWorkbookForCreateWB.find(wb => wb.id === workbookId) || null;
    
    if (workbookId) {
      this.getSourceWorkbookColumns(workbookId);
    }
  }

  getSourceWorkbookColumns(workbookId: string) {
    this.appMainService.isShowSpinner('getSourceWorkbookColumns');
    this.dynamicTableService.getDynamicTableColumn(workbookId).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
      next: (response: ColumnDefinition[]) => {
        this.appMainService.isHideSpinner('getSourceWorkbookColumns');
        this.sourceWorkbookColumns = [...response];
        this.selectedColumnForNewWb = structuredClone(response);
      },
      error: (error) => {
        this.appMainService.isHideSpinner('getSourceWorkbookColumns');
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to fetch columns for the selected workbook'
        });
      }
    });
  }
  //#endregion  
}
